(function() {
    'use strict';

    angular
        .module('Controllers')
        .controller('MainController', MainController);

    function MainController($scope, lodash, $http, $q, Path, Action, Request, Notifier, MasterLayoutService, ButtonRegistry, $injector, MainService, PageDirtyChecker, $window, FormBuilderService, $location, AccessMainCtrl, $route) {
        var stopWatchingLocation = null;
        $scope.allowLocationChange = false;
        $scope.currentLocation = $location.url();

        $scope.success = false;
        $scope.mainService = MainService($scope);

        AccessMainCtrl.setMainControllerScope($scope);
        AccessMainCtrl.set('mainService', $scope.mainService);

        FormBuilderService.initApp($scope);
        // Defer and init
        $q.all([
            $scope.templateLoader.promise,
            $scope.initLoader.promise,
            $scope.initPortalLoader.promise
        ]).then(function () {
            init();
        });

        $scope.$watch(watchRequestService, watchRequestServiceFunc);
        $scope.$watch(pageDataWatchRequest, pageDataWatchRequestFunc);
        $window.addEventListener('beforeunload', beforeUnloadEvent);

        //https://www.bennadel.com/blog/2808-asking-the-user-to-confirm-location-or-route-changes-in-angularjs.htm


        // initialization
        $scope.getUserProfile = getUserProfile;

        /**
         * Function to initialise App in Portal
         */
        function init() {
            //$scope.mainIndexData = MasterLayoutService.get();

            var currentPath = Path.getPathInfo();
            $scope.mainService.getStructure(currentPath);
            $scope.$on('$locationChangeSuccess', locationChangeSuccess);
            stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
        }


        /**
         * Function to get user profile information
         */
        function getUserProfile() {
            var path = Path.getApiPath('/account/user/getProfile');
            $http.get(path).then(function (res) {
                if (res.data.success) {
                    $scope.user = res.data;
                } else {
                    $scope.user = false;
                }
            }, function () {
                $scope.user = false;
            });
        }

        /*
         * REQUEST HANDLING PORTION
         * Currently, What i understand is that data manipulation should happen in controller.
         * So the snippet below is meant to attempt to follow that.
         */
        function sendRequest(request) {
            // TODO: SODO: Need to handle actions from the modal
            var defer = $q.defer();
            // TODO: SODO: make sure Id are replaced at webserver
            var path = Path.getApiPath(request.getRoute());

            $scope.content.validation = {};
            $http[request.getMethod()](path, request.getData())
                .then(function (res) {
                    var eventData = request.getEventData();
                    if (eventData.fbService && eventData.fbService.eventsService) {
                        eventData.fbService.eventsService.setPristine();
                    }

                    Action.run('', res.data.actions, $scope.content, request.getEventData(), $scope);
                    defer.resolve();

                    // if actions contains redirect, don't clear loading.
                    var redirectActions = lodash.filter(res.data.actions, function(action, index) {
                        return (index.indexOf('redirect') >= 0);
                    });
                    if (redirectActions.length == 0) {
                        ButtonRegistry.clearAllLoading();
                    }
                }, function (res) {
                    if (res.status == 422) {
                        var rules = res.data.rules;
                        var summary = lodash.get(res.data, 'summary', null);
                        var eventData = request.getEventData();
                        if ($scope.content.view_events[request.getData().event]) {
                            var submitAction = $scope.content.view_events[request.getData().event].form_submit;
                            var formIdentifier = lodash.get(submitAction, 'form_name', lodash.get(eventData,'formIdentifier', false));

                            if (typeof submitAction.schema != typeof undefined) {
                                rules = Action.reverseMapField($scope.content.view_events[request.getData().event].form_submit.schema, rules);
                            }

                            if (formIdentifier) {
                                var FormBuilderService = $injector.get('FormBuilderService');
                                var fbService = FormBuilderService.get(formIdentifier);
                                fbService.elementsService.setValidationRules(rules, summary);
                            } else {
                                // Shouldn't run anymore
                                Action.run('', {
                                    'validate': {
                                        rules: rules,
                                        summary: lodash.get(res.data, 'summary', null),
                                        form_name: res.data.form_name
                                    }
                                }, $scope.content, eventData, $scope);
                            }

                        } else {
                            // Shouldn't run anymore
                            Action.run('', {
                                'validate': {
                                    rules: rules,
                                    summary: summary,
                                    form_name: res.data.form_name
                                }
                            }, $scope.content, eventData, $scope);
                        }
                    }
                    ButtonRegistry.clearAllLoading();
                    defer.resolve();
                });
            return defer.promise;
        }

        function watchRequestService() {
            return Request.requestUpdated();
        }

        function watchRequestServiceFunc() {
            // start showing loading
            Notifier.setLoading(true);
            var requests = Request.getRequest();
            var requestQ = [];
            angular.forEach(requests, function (req) {
                // sendRequest, and get back promise
                requestQ.push(sendRequest(req));
            });

            $q.all(requestQ).then(function () {
                // execute once all promises are resolved
                Notifier.setLoading(false);
            });
        }

        function pageDataWatchRequest() {
            return MasterLayoutService.change();
        }

        function pageDataWatchRequestFunc() {
            $scope.mainIndexData = MasterLayoutService.get();
        }

        function locationChangeStart(e, nextPath, prevPath) {
            if (typeof stopWatchingLocation === typeof function () {
                }) {
                // console.log

                if (PageDirtyChecker.hasDirtyForm()) {
                    e.preventDefault();

                    var targetPath = $location.path();
                    var targetSearch = $location.search();
                    var targetHash = $location.hash();
                    PageDirtyChecker.showConfirmation().then(function () {
                        $location
                            .path(targetPath)
                            .search(targetSearch)
                            .hash(targetHash)
                            .replace()
                        ;
                        stopWatchingLocation();
                        stopWatchingLocation = null;
                    });
                } else {
                    stopWatchingLocation();
                    stopWatchingLocation = null;
                }
            }
        }

        function locationChangeSuccess(evt, newpath, oldpath) {

            var prevPathObj = Path.getPathInfo(oldpath);
            var nextPathObj = Path.getPathInfo(newpath);
            if (isPathDifferent(prevPathObj, nextPathObj)) {
                $scope.currentLocation = $location.url();
                $scope.mainService.getStructure(prevPathObj);
            } else {
                if (Path.paramsIsDiff(prevPathObj.params(), nextPathObj.params())) {
                    $scope.$broadcast('actions.paramsChange', nextPathObj.params());
                }
            }
            if (typeof stopWatchingLocation !== typeof function() {}) {
                stopWatchingLocation = $scope.$on("$locationChangeStart", locationChangeStart);
            }
        }

        function isPathDifferent(oldPath, newPath) {
            if (oldPath.structurePath() == newPath.structurePath()) {
                return false;
            } else {
                return true;
            }
        }

        function beforeUnloadEvent(e) {

            // http://stackoverflow.com/questions/276660/how-can-i-override-the-onbeforeunload-dialog-and-replace-it-with-my-own
            // no way to use our modal to override the behavior. Too bad. Live with it.
            if (!(typeof function(){} === typeof PageDirtyChecker.verify)) {
                delete e.returnValue;
                return undefined;
            }

            if (PageDirtyChecker.verify()) {
                var confirmationMessage = " ";
                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Webkit, Safari, Chrome
            }
            delete e.returnValue;
            return undefined;
        }
    }
})();